import { action, makeObservable, observable } from 'mobx'
import { GetCurrentUserWorkspaceMemberships } from 'iam/WorkspaceMembershipStore'
import OCRScopingJobSidePanelViewModel from './components/SidePanel/OCRScopingJobSidePanelViewModel'
import OCRScopeWorkStore from 'wunder/OCRScopeWorkStore'
import { task } from 'mobx-task'
import Member from 'iam/models/Member'
import { Observable } from 'rxjs'
import CreateOCRScopeJobsViewModel from './views/CreateOCRScopeJobsDialog/CreateOCRScopeJobsViewModel'
import PublishedLegendStore from 'legends/PublishedLegendStore'
import MemberStore from 'iam/MemberStore'
import { FindUserTeamMembersByUserPublicId } from 'iam/TeamMemberStore'
import { AlertFactory } from 'alerts/Alert'
import { Router } from '../../../types/definitions'
import OCRScopingJobsPermissionViewModel from './OCRScopingJobsPermissionViewModel'
import OCRScopingJobMainPanelViewModel from './components/MainPanel/OCRScopingJobMainPanelViewModel'
import JobCreationDialogViewModel from '../../creation/views/JobCreationDialog/JobCreationDialogViewModel'
import JobCreationRootViewModel from '../../creation/JobCreationRootViewModel'
import DocumentStore from '../../../documents/DocumentStore'
import JobStore from '../../JobStore'

/**
 * View model for scoping jobs.
 */
export default class OCRScopingJobsViewModel {
  ocrScopingJobsPermissionViewModel = new OCRScopingJobsPermissionViewModel(
    this.getCurrentUserWorkspaceMemberships
  )

  ocrScopingJobMainPanelViewModel = new OCRScopingJobMainPanelViewModel(
    this.ocrScopingJobsPermissionViewModel,
    this.ocrScopeWorkStore,
    this.publishedLegendStore,
    this.documentStore,
    this.currentMember$,
    this.router,
    this.newAlert,
    this.jobCreationRootVM,
    new JobCreationDialogViewModel(
      this.router,
      this.newAlert,
      this.jobCreationRootVM
    )
  )

  ocrScopingJobSidePanelViewModel = new OCRScopingJobSidePanelViewModel(
    this.ocrScopingJobsPermissionViewModel,
    this.ocrScopingJobMainPanelViewModel,
    this.ocrScopeWorkStore,
    this.jobStore,
    this.getCurrentUserWorkspaceMemberships,
    this.currentMember$,
    this.newAlert
  )

  createOCRScopeJobsViewModel = new CreateOCRScopeJobsViewModel(
    this.ocrScopeWorkStore,
    this.memberStore,
    this.publishedLegendStore,
    this.getCurrentUserWorkspaceMemberships,
    this.currentMember$,
    this.findTeamMembersByUserPublicId,
    this.newAlert
  )

  /**
   * Whether the side panel is visible.
   */
  @observable sidePanelVisible = true

  @action.bound
  toggleSidePanelVisibleVisibility() {
    this.sidePanelVisible = !this.sidePanelVisible
  }

  constructor(
    private getCurrentUserWorkspaceMemberships: GetCurrentUserWorkspaceMemberships,
    private ocrScopeWorkStore: OCRScopeWorkStore,
    private jobStore: JobStore,
    private publishedLegendStore: PublishedLegendStore,
    private memberStore: MemberStore,
    private documentStore: DocumentStore,
    private currentMember$: Observable<Member>,
    private findTeamMembersByUserPublicId: FindUserTeamMembersByUserPublicId,
    private newAlert: AlertFactory,
    private router: Router,
    private jobCreationRootVM: JobCreationRootViewModel
  ) {
    makeObservable(this)
  }

  activate = task.resolved(async () => {
    await this.ocrScopingJobSidePanelViewModel.activate()
  })

  deactivate() {
    this.ocrScopingJobSidePanelViewModel.deactivate()
    this.ocrScopingJobMainPanelViewModel.deactivate()
  }
}
